export const toolCategories = [
  { id: "all", label: "All Tools" },
  { id: "downloader", label: "Downloaders" },
  { id: "converter", label: "Converters" },
];

export const tools = [
  {
    slug: "youtube-downloader",
    title: "YouTube Video Downloader",
    description: "Download YouTube videos in HD quality. Paste any YouTube link and save to your device.",
    category: "downloader",
    color: "rose",
    gradient: "from-red-600/20 to-red-400/5",
    placeholder: "https://www.youtube.com/watch?v=...",
    platform: "youtube",
    tags: ["youtube", "video download", "mp4"],
    seoIntro:
      "Download YouTube videos in HD quality for free. Paste any public YouTube URL and save the video to your device — fast, browser-based, and no account needed.",
  },
  {
    slug: "instagram-downloader",
    title: "Instagram Video Downloader",
    description: "Save Instagram reels, stories, and posts. Download videos and images instantly.",
    category: "downloader",
    color: "violet",
    gradient: "from-pink-600/20 to-purple-400/5",
    placeholder: "https://www.instagram.com/reel/...",
    platform: "instagram",
    tags: ["instagram", "reels", "stories"],
    seoIntro:
      "Save Instagram reels, stories, and posts instantly. Paste an Instagram link to download videos and images — free and easy to use in your browser.",
  },
  {
    slug: "twitter-downloader",
    title: "Twitter / X Video Downloader",
    description: "Download videos from Twitter/X posts. Paste the tweet URL and save the video.",
    category: "downloader",
    color: "cyan",
    gradient: "from-sky-600/20 to-cyan-400/5",
    placeholder: "https://twitter.com/user/status/...",
    platform: "twitter",
    tags: ["twitter", "x", "video download"],
    seoIntro:
      "Download videos from Twitter and X posts in seconds. Paste a tweet URL to extract and save the video — no software install required.",
  },
  {
    slug: "video-to-mp3",
    title: "Video to MP3 Converter",
    description: "Extract audio from any video file. Convert MP4, MOV, and more to high-quality MP3.",
    category: "converter",
    color: "emerald",
    gradient: "from-accent-emerald/20 to-accent-emerald/5",
    tags: ["mp3", "audio", "converter"],
    seoIntro:
      "Extract audio from video files and convert to high-quality MP3. Upload MP4, MOV, or other formats and download the audio track in your browser.",
  },
  {
    slug: "doc-to-pdf",
    title: "DOC to PDF Converter",
    description: "Convert Word documents (.doc, .docx) to PDF instantly. Free, fast, and secure in your browser.",
    category: "converter",
    color: "primary",
    gradient: "from-primary-600/20 to-primary-400/5",
    tags: ["pdf", "word", "document"],
    seoIntro:
      "Convert Word documents to PDF online for free. Upload .doc or .docx files and get a polished PDF instantly — secure, private, and processed in your browser.",
  },
  {
    slug: "image-to-pdf",
    title: "Image to PDF Converter",
    description: "Convert JPG, PNG, and WebP images to PDF. Merge multiple images into one PDF file.",
    category: "converter",
    color: "violet",
    gradient: "from-accent-violet/20 to-accent-violet/5",
    tags: ["pdf", "image", "jpg", "png"],
    seoIntro:
      "Turn JPG, PNG, and WebP images into PDF files. Merge multiple images into a single PDF document — free, fast, and works entirely in your browser.",
  },
];

export const getToolBySlug = (slug) => tools.find((t) => t.slug === slug);
